var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('list-voucher', {
    attrs: {
      "do-update": _vm.reloadVoucher,
      "clientId": _vm.clientId,
      "visitId": _vm.visitId
    },
    on: {
      "updated": _vm.updateVoucherDone
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('add-voucher', {
    attrs: {
      "client-id": _vm.clientId,
      "visit-id": _vm.visitId,
      "copied-voucher": _vm.voucherToCopy
    },
    on: {
      "update": _vm.updateVoucher
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-light"
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b24a5fea","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/VisitVoucher.vue
// module id = 592
// module chunks = 0